import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import moment from 'moment';
import {cashboxReset} from '../../../../redux/actions/handbookAction';
import {DSelect, HookForm} from '../../../../validation/HForm';
import calculationCouponFormSchema from './calculationCouponFormSchema';
import {listRoles, todayStart} from '../../../../helpers/data-constants'
import {calculationAccess, getDaysUntilEndDate, getValidDurationCoupons, isCurrentTimeInRange} from '../../../../helpers/common';

const defaultFormState = {
  coupon: { value: '', label: '' },
};

const CalculationCouponForm = ({
                                 cashboxes,
                                 updateCashBox,
                                 cashBox,
                                 onUpdate,
                                 isClear,
                                 onError,
                                 defaultCoupon,
                                 defaultCashBox,
                                 waiverOfRedemption,
                                 calculationAmount,
                                 calculationEndDate,
                                 calculateEndMonths,
                                 calculateFirstPaymentDate,
                               }) => {

  const dispatch = useDispatch();
  const [coupons, setCoupons] = useState([]);
  const [duration, setDuration] = useState([]);
  const [availableCashBoxes, setAvailableCashBoxes] = useState([])
  const [ error, setError ] = useState('')
  const { typeOfDeal } = useSelector(({ contract }) => contract);
  const { wasSaved } = useSelector((state) => state.quickCalculation);
  const { client } = useSelector(({ clientInfo }) => clientInfo);
  const { accessFeatures } = useSelector(({ user }) => user);
  const history = useHistory()
  const adminRole = calculationAccess([listRoles.ADMIN])

  let form = {};

  const findCoupon = (coupons, amount, calculateEndDate, calculateEndMonths, calculateFirstPaymentDate) => {
    if (!coupons) return null;

    const isHybrid = Boolean(calculateFirstPaymentDate);
    const endDate = isHybrid ? calculateFirstPaymentDate : calculateEndDate;
    const daysUntilEndDate = endDate && getDaysUntilEndDate(endDate);
    
    const shouldCheckDuration = accessFeatures["client.category"] && (daysUntilEndDate || calculateEndMonths);
    
    for (const coupon of coupons) {
      for (const couponRow of coupon.couponRowList) {
        const { startPrice, endPrice } = couponRow;
        
        let hasValidDuration = true;
        if (shouldCheckDuration) {
          if (isHybrid) {
            hasValidDuration = daysUntilEndDate >= coupon.minDuration && 
                            daysUntilEndDate <= coupon.maxDuration && 
                            calculateEndMonths >= couponRow.minAnnuityDuration && 
                            calculateEndMonths <= couponRow.maxAnnuityDuration;
          } else {
            const duration = daysUntilEndDate || calculateEndMonths;
            hasValidDuration = duration >= coupon.minDuration && 
                            duration <= coupon.maxDuration;
          }
        }

        if (startPrice <= amount && amount <= endPrice && hasValidDuration) {
          return [coupon];
        }
      }
    }
    
    return null;
  }

  useEffect(() => {
    if (adminRole && cashboxes.length !== 0) {
       const actualCashBoxes = cashboxes.map((department) => ({
         value: department.id,
         label: department.name
       }));
       setAvailableCashBoxes(actualCashBoxes)
    }
  }, [cashboxes])

  useEffect(() => {
    if ( cashBox.coupons ) {
      let newCashBox;
      let activeCoupons;
      if (typeOfDeal === 'jewellery') {
        ({ newCashBox, activeCoupons } = filteredCoupon('PURITY'));
      } else if (typeOfDeal === 'things') {
        ({ newCashBox, activeCoupons } = filteredCoupon('THINGS'));
      } else if (typeOfDeal === 'cars') {
        ({ newCashBox, activeCoupons } = filteredCoupon('CARS'));
      }

      activeCoupons = (calculateEndMonths || calculationEndDate) && accessFeatures["client.category"]
        ? getValidDurationCoupons(activeCoupons, calculationEndDate, calculateEndMonths, calculateFirstPaymentDate)
        : activeCoupons;

      let data;

      if (activeCoupons?.length) {
        const newCoupons = activeCoupons.map((c) => ({
          value: c.id,
          label: c.name,
          inactive: moment(c.startDate).valueOf() > todayStart || moment(c.endDate).valueOf() < todayStart,
        }));
        const newDuration = activeCoupons.map((c) => ({
          value: c.id,
          maxDuration: c.maxDuration,
          minDuration: c.minDuration,
        }));

        setDuration(newDuration);
        setCoupons(newCoupons);

        if (wasSaved) {
          if (!accessFeatures["client.category"]) {
            const isDefaultCouponActive = activeCoupons.find(item => item.id === defaultCoupon.value)
            !isDefaultCouponActive && setError('Купон неактивеный')
          }
          form.setValue('cashbox', {
            value: defaultCashBox.value,
            label: defaultCashBox.label,
          })
            form.setValue('coupon', {
            value: (!defaultCoupon.value) ? '' : ((accessFeatures["client.category"]) ? activeCoupons[0].id :defaultCoupon.value ),
            label: (!defaultCoupon.value) ? '' : ((accessFeatures["client.category"]) ? activeCoupons[0].name : defaultCoupon.label),
          })
          if(!defaultCoupon.value) { setError('Купон был изменен либо удален, выберите купон') }

          let currentCoupon = newCashBox.coupons.find(coupon => coupon.id === ((accessFeatures["client.category"]) ? activeCoupons[0].id :defaultCoupon.value))
          data = form.getValues();
          data.minDuration = currentCoupon?.minDuration;
          data.maxDuration = currentCoupon?.maxDuration;
        } else {
          const currentCoupon = newCoupons.find(c=> c.value===defaultCoupon.value )
          const currentDuration = newDuration.find(c=> c.value===defaultCoupon.value )

          form.setValue('coupon', {
            value: currentCoupon && !accessFeatures["client.category"] ? currentCoupon.value : newCoupons[0].value,
            label: currentCoupon && !accessFeatures["client.category"] ? currentCoupon.label : newCoupons[0].label,
          });
          form.setValue('cashbox', {
            value: cashBox.id,
            label: cashBox.name,
          })
          setError('')
          data = form.getValues();
          data.minDuration = currentDuration ? currentDuration?.minDuration : newDuration[0].minDuration;
          data.maxDuration = currentDuration ? currentDuration?.maxDuration : newDuration[0].maxDuration;
        }
        onUpdate(data);
        newCoupons[0].inactive ?
          onError && onError('Купон неактивный') :
          onError && onError('')
      } else {
        onError && onError( waiverOfRedemption ? `Обратитесь к администратору для создания купона 'Отказ от выкупа'` : 'Нет активных купонов');
        setCoupons([])
        setDuration([])
        form.setValue('cashbox', {
          value: cashBox.id,
          label: cashBox.name,
        });
        form.setValue('coupon', {
          value: '',
          label: '',
        });
        data = form.getValues();
        onUpdate(data);
      }
    }
  }, [cashBox, typeOfDeal, waiverOfRedemption, wasSaved, client.categories, calculationAmount, calculationEndDate, calculateEndMonths, calculateFirstPaymentDate]);

  useEffect(() => {
    if (isClear) {
      if (defaultCoupon) {

        const data = form.getValues();
        data.minDuration = duration[0]?.minDuration;
        data.maxDuration = duration[0]?.maxDuration;

        onUpdate(data);
      }
    }
  }, [isClear, coupons, form, onUpdate, duration]);

  const getValidTimeCoupons = (coupons, typeValue, category) => {
    return coupons.filter(coupon =>
        coupon.timeLimit &&
        isCurrentTimeInRange(coupon.timeFrom, coupon.timeTo) &&
        coupon.type.includes(typeValue) &&
        coupon.category === category
    );
  };

  const filteredCoupon = (typeValue) => {
    const newCashBox = cashBox;
    let activeCoupons = newCashBox.coupons.sort((a, b) => a.name.localeCompare(b.name, undefined, {numeric: true,})).filter(({active}) => active);
    if (typeOfDeal === 'jewellery' || typeOfDeal === 'things' || typeOfDeal === 'cars') {
      if (accessFeatures["client.category"]) {

        if (client?.categories?.length > 0) {
          let validTimeCoupons = getValidTimeCoupons(newCashBox.coupons, typeValue, client.categories[0].id)
          activeCoupons = validTimeCoupons.length > 0
              ? validTimeCoupons
              : newCashBox.coupons.filter(({type, category, timeLimit}) => type.includes(typeValue) && category === (client?.categories[0].id) && !timeLimit);

          calculationAmount && (activeCoupons = findCoupon(activeCoupons, calculationAmount, calculationEndDate, calculateEndMonths, calculateFirstPaymentDate));
          !activeCoupons?.length && (activeCoupons = newCashBox.coupons.filter(({type, category, timeLimit}) => type.includes(typeValue) && category === null && !timeLimit))
        } else {
          let validTimeCoupons = getValidTimeCoupons(newCashBox.coupons, typeValue, null);
          activeCoupons = validTimeCoupons.length > 0
              ? validTimeCoupons
              : newCashBox.coupons.filter(({type, category, timeLimit}) => type.includes(typeValue) && category === null && !timeLimit)
        }
        let validTimeCoupons = getValidTimeCoupons(newCashBox.coupons, typeValue, 10);
        waiverOfRedemption && typeOfDeal !== 'cars' && (activeCoupons = validTimeCoupons.length > 0
            ? validTimeCoupons
            : newCashBox.coupons.filter(({category, type, timeLimit}) => category === 10 && type.includes(typeValue) && !timeLimit));
        !!calculationAmount && (activeCoupons = findCoupon(activeCoupons, calculationAmount, calculationEndDate, calculateEndMonths, calculateFirstPaymentDate));
        if (!activeCoupons?.length) {
          activeCoupons = newCashBox.coupons.filter(({ type, timeLimit }) => type.includes(typeValue) && !timeLimit);
        }
      } else {
        activeCoupons = newCashBox.coupons.filter(({ type }) => type.includes(typeValue));
      }
    } 
    return { newCashBox, activeCoupons };
  }

  const handleChange = () => {
    setError('')
    const data = form.getValues();
    const idx = coupons.findIndex((i) => i.value === data.coupon.value);
    data.minDuration = duration[idx].minDuration;
    data.maxDuration = duration[idx].maxDuration;

    onUpdate(data);
    if (data.coupon.inactive) {
      onError && onError('Купон неактивный')
      window.scrollTo(0, 0)
    } else {
      onError && onError('')
    }
  };

  const handleChangeCashBox = () => {
    const selectedCashBox = form.getValues().cashbox;
    updateCashBox(selectedCashBox.value)
  }

  const handleOptions = (e, action) => {
    if (action.action === 'input-change') {
      let filterCashBox = cashboxes.filter(c => c.name.toLowerCase().startsWith(e.toLowerCase())).map((department) => ({
        value: department.id,
        label: department.name}))
      setAvailableCashBoxes(filterCashBox);
    }
  };

  const resetCashBoxHandler = useCallback(() => {
    const isQuickCalculation = Boolean(history.location?.state?.isQuickCalculation)
    if(!isQuickCalculation) {
      dispatch(cashboxReset())
    }
  }, [dispatch, history.location])

  useEffect(() => {
    return resetCashBoxHandler
  }, [])

  return (
    <HookForm
      validationSchema={calculationCouponFormSchema}
      defaultValues={defaultFormState}
      predef={(methods) => (form = methods)}>
      <fieldset>
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="cashBox">
                Подразделение
              </label>
              <div className="form-element-data combobox">
                <DSelect
                  h="true"
                  name="cashbox"
                  options={ adminRole && availableCashBoxes }
                  isLoading={false}
                  placeholder="Название"
                  handleOptions={handleOptions}
                  handleOnChange={ adminRole && handleChangeCashBox }
                  isDisabled={ !adminRole }
                />
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="">
                Категории
              </label>
              <div className="form-element-data combobox">
                <DSelect
                  h="true"
                  name="coupon"
                  options={coupons}
                  isLoading={false}
                  placeholder="Название"
                  handleOnChange={handleChange}
                />
              </div>
              <span className={'error'}>{error}</span>
            </div>
          </div>
        </div>
      </fieldset>
    </HookForm>
  );
};

export default CalculationCouponForm;
